import { localize } from 'helpers/router';

export const PRICES = localize('/price');
